import { ReactNode, useContext } from "react";
import { connect, useDispatch } from "react-redux";
import { setCurrentCompany } from "./store/reducers/currentUserSlice";
import { auth as snowLibAuth } from "@mysnowscape/snow-lib";
import { CurrentUser } from "./store/storeTypes";
import { AuthContext } from "./AuthContext";

const CurrentCompanyManager = ({
  currentUser,
  children,
}: {
  currentUser: CurrentUser | null;
  children: ReactNode;
}) => {
  const { authUser } = useContext(AuthContext);
  const dispatch = useDispatch();

  if (currentUser?.currentCompanyId && authUser !== null) {
    if (
      !snowLibAuth.canViewCompany(currentUser, currentUser.currentCompanyId)
    ) {
      console.log("dispatching a clear company");
      dispatch(setCurrentCompany(null));
    }
  }

  return children;
};

const mapStateToProps = (state: { currentUser: CurrentUser }) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(CurrentCompanyManager);
